import styled from "@emotion/styled";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton, Stack, Typography } from "@mui/material";
import { useChurchStore } from "features/churches";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useBudgetYears } from "../api";
import { BudgetTimelineTable, SetBudgetModal } from "../components";

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 25%;
`;

const Label = styled.label`
  color: #5b5b5b;
  font-size: 12px;
  font-weight: 500;
`;

const Select = styled.select`
  border-radius: 4px;
  border: 0.73px solid #b3b3b3;
  height: 40px;
  outline: none;
  padding: 8px;
  font-family: inherit;
  flex: 1;
  background-color: transparent;
`;

export const BudgetDetails = () => {
  const [budgetYear, setBudgetYear] = useState("");

  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const budgetYearParam = searchParams.get("budget-year");

  const { id } = useParams();

  const budgetYearsQuery = useBudgetYears({
    churchId: selectedChurch?.id
  });

  useEffect(() => {
    if (budgetYearsQuery.data?.result?.length > 0) {
      setBudgetYear(budgetYearParam || budgetYearsQuery.data?.result?.[0]?.id);
    }
  }, [budgetYearsQuery.data?.result]);

  return (
    <Stack spacing={3}>
      <Stack direction="row" alignItems="center">
        <IconButton onClick={() => navigate(`/finances/temp/budget`)}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
        <Typography variant="caption">Back to budget</Typography>
      </Stack>
      <Stack direction="row" spacing={2}>
        <Field>
          <Label htmlFor="department">Select Budget Year</Label>
          <Select
            id="department"
            value={budgetYear}
            onChange={e => setBudgetYear(e.target.value)}
            disabled={budgetYearsQuery.data?.result?.length === 0}
          >
            {budgetYearsQuery.data?.result?.map(budgetYear => (
              <option key={budgetYear.id} value={budgetYear.id}>
                {budgetYear.title}
              </option>
            ))}
          </Select>
        </Field>
      </Stack>
      <BudgetTimelineTable teamId={id} budgetYear={budgetYear} />
      <SetBudgetModal teamId={id} budgetYear={budgetYear} />
    </Stack>
  );
};
